// extracted by mini-css-extract-plugin
module.exports = {"tableDisplay":"styles_tableDisplay__2xLJ1","withoutActions":"styles_withoutActions__1_nJA"};